import { isDefined } from '../../utils/types';

import type { Column } from './table';

export const createColumns = <T>(item: (Column<T> | undefined)[]) => item.filter(isDefined);
